export default __webpack_public_path__ + "static/media/anime-excited.d600d751.gif";